import styled from "styled-components";

export const PageBackground = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  background-color: ${(props) => props.theme.tokens.colors.bg};
`;

export const PageShell = styled.div`
  width: 100%;
  max-width: 480px;
  min-height: 100vh;
  position: relative;
  background-color: ${(props) => props.theme.tokens.colors.bg};
  padding-bottom: 110px;
`;

export const SectionTitle = styled.h2`
  font-weight: 900;
  font-size: 18px;
  color: ${(props) => props.theme.tokens.colors.ink};
  letter-spacing: -0.3px;
  padding: 20px 16px 6px;
  font-family: ${(props) => props.theme.tokens.font.family};
`;

export const ProductListPad = styled.div`
  padding: 0 16px;
`;

// Espelha o EmptySearch do desktop (components/desktop/DesktopShell.styles.ts):
// com a busca ativa e nenhum grupo restante, a lista mobile ficaria em branco.
export const EmptySearch = styled.div`
  padding: 60px 20px;
  text-align: center;
  color: ${(props) => props.theme.tokens.colors.muted};
  font-size: 14px;
  font-family: ${(props) => props.theme.tokens.font.family};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.tokens.colors.bg};
  padding-bottom: 50px;
`;

export const Form = styled.div`
  width: 50vw;
  background-color: ${(props) => props.theme.tokens.colors.surface};
  padding: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  border-radius: 8px;

  @media (max-width: 1024px) {
    width: 98vw;
    padding: 5px;
  }
`;

export const FormTitle = styled.h2`
  color: ${(props) => props.theme.tokens.colors.ink};
  font-size: 32px;
  font-family: ${(props) => props.theme.tokens.font.family};
  font-weight: 600;

  padding-bottom: 10px;
`;

// NOTE: also duplicated in components/ProductCard.styles.ts — still used
// directly in this file by the module-level getPriceLeft() helper. See Task
// 17 in docs/superpowers/plans/2026-07-10-store-modularizacao.md.
export const LabelPriceLeft = styled.p`
  color: ${(props) => props.theme.tokens.colors.ink};
  font-size: 15px;
  font-family: ${(props) => props.theme.tokens.font.family};
  font-weight: 700;
`;

// NOTE: also duplicated in components/ProductCard.styles.ts — still used
// directly in this file by the module-level getPriceLeft() helper. See Task
// 17 in docs/superpowers/plans/2026-07-10-store-modularizacao.md.
export const LabelPromotion = styled.div`
  color: ${(props) => props.theme.tokens.colors.red};
  font-size: 15px;
  font-family: ${(props) => props.theme.tokens.font.family};
  font-weight: 500;

  display: block;
  margin-top: 5px;
  padding-left: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
  width: 100px;

  border: 2px solid ${(props) => props.theme.tokens.colors.red};
  border-radius: 20px;
`;

// NOTE: also duplicated in components/ProductCard.styles.ts — still used
// directly in this file by the module-level getPriceLeft() helper. See Task
// 17 in docs/superpowers/plans/2026-07-10-store-modularizacao.md.
export const LabelPriceOldLeft = styled.p`
  font-size: 10px;
  text-decoration: line-through;
  font-style: italic;
  font-family: ${(props) => props.theme.tokens.font.family};
`;

export const ImageOnChef = styled.img.attrs(() => ({
  //src: "home-image.svg",
  src: "../../logo_padrao.png",
}))`
  width: 90px;
  margin-top: 16px;
`;

// NOTE: also duplicated in components/StoreHeader.styles.ts — still used
// directly in this file by the loading ShowModal (not part of the header).
// This duplication was not anticipated by the Task 9 plan text (which only
// called out Label/ImageCart); flagging it for Task 17 alongside those.
export const LeftContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

// NOTE: also duplicated in components/ProductCard.styles.ts — still used
// directly in this file by the module-level getPriceLeft() helper. See Task
// 17 in docs/superpowers/plans/2026-07-10-store-modularizacao.md.
export const ContainerPriceLeft = styled.div`
  margin-top: 5px;
`;
